import React, { Component } from "react";

import { withRouter } from "react-router-dom";

import { withStyles } from "@material-ui/core/styles";

import Typography from "@material-ui/core/Typography";

import Title from "../Title";

import moment from "moment";

import Check from "../../../static/images/checkmark.png";

import ApplicationLocaleProvider from "../../../i18n/ApplicationLocaleProvider";
import LanguageSwitch from "../../../i18n/LanguageSwitch";
import { resolveLocale } from "../../../i18n/locale";
import { getTranslator } from "../../../i18n/translate";

import styles from "./styles";
import MerchantShell from "../application-steps/Shell";
import { StepHeader } from "../application-steps/ui";
import { usesNewApplicationFlow } from "../flow";
import CheckCircleOutline from "@material-ui/icons/CheckCircleOutline";

class Confirmation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      application: props.location.state.application,
      completedAt: moment().format("L LT"),
      locale: resolveLocale({ override: props.location.state.locale })
    };
  }
  render() {
    const { application } = this.state;
    const { classes } = this.props;
    const { locale } = this.state;
    const t = getTranslator(locale);
    if (this.props.location.state.newApplicationFlow && usesNewApplicationFlow(this.props.location.state.isCheckout)) {
      return <ApplicationLocaleProvider locale={locale}>
        <MerchantShell application={application} locale={locale} onLocaleChange={locale => this.setState({ locale })} confirmation>
          <div className="merchant-confirmation"><CheckCircleOutline />
            <StepHeader title="Thank You!">Your application was successfully submitted and is pending approval.</StepHeader>
            <p>{t("When your application is approved, we will send you an email within two business days (or sooner) that contains instructions to start processing credit cards with your new merchant account.")}</p>
            <dl><dt>{t("Application Number:")}</dt><dd>{application.id}</dd>
              <dt>{t("Application Date:")}</dt><dd>{this.state.completedAt}</dd>
              <dt>{t("Business Name:")}</dt><dd>{application.legalBusinessName}</dd>
              <dt>{t("Email Address:")}</dt><dd>{application.email}</dd></dl>
          </div>
        </MerchantShell>
      </ApplicationLocaleProvider>;
    }
    return (
      <ApplicationLocaleProvider locale={locale}>
      <LanguageSwitch
        locale={locale}
        onChange={locale => this.setState({ locale })}
      />
      <div className={classes.root}>
        <div className={classes.checkContainer}>
          <img className={classes.check} src={Check} alt={t("Confirmation")} />
        </div>
        <Title
          h1={t("Thank You!")}
          h2={t(
            "Your application was successfully submitted and is pending approval."
          )}
        />
        <div className={classes.confirmContainer}>
          <Typography
            className={classes.textBlock}
            variant="body1"
            gutterBottom
          >
            {t(
              "When your application is approved, we will send you an email within two business days (or sooner) that contains instructions to start processing credit cards with your new merchant account."
            )}
          </Typography>
          <Typography variant="body1" gutterBottom>
            <b>{t("Application Number:")}</b> {application.id}
          </Typography>
          <Typography variant="body1" gutterBottom>
            <b>{t("Application Date:")}</b> {this.state.completedAt}
          </Typography>
          <Typography variant="body1" gutterBottom>
            <b>{t("Business Name:")}</b> {application.legalBusinessName}
          </Typography>
          <Typography variant="body1" gutterBottom>
            <b>{t("Email Address:")}</b> {application.email}
          </Typography>
        </div>
      </div>
      </ApplicationLocaleProvider>
    );
  }
}

export default withRouter(withStyles(styles)(Confirmation));
